import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DroneService } from 'src/app/services/drone/drone.service';

@Component({
  selector: 'app-create-drone',
  templateUrl: './create-drone.component.html',
  styleUrls: ['./create-drone.component.sass']
})
export class CreateDroneComponent implements OnInit {
  public form: FormGroup;
  id: string;
  title: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private activatedRouter: ActivatedRoute,
    private readonly router: Router,
    private readonly droneService: DroneService,
    private readonly toastr: ToastrService,
    private _t: TranslateService
  ) { }

  /** Returns true when valid */
  get isFormValid() {
    return Object.keys(this.form.controls).every(key => this.form.controls[key].valid)
  }

  ngOnInit(): void {
    this.id = this.activatedRouter.snapshot.paramMap.get('id')
    this.title = this._t.instant("Register New Drone");
    if (this.id) {
      this.title = this._t.instant("Update Drone Info");
      this.droneService.findOne(this.id).subscribe(res => {
        
        this.form.patchValue({
          name: res.name,
          brand: res.brand,
          model: res.model,
          manufacturing_year: res.manufacturing_year,
          serial_number: res.serial_number,
          weight: res.weight,
          length: res.length,
          wingspan: res.wingspan,
          power_source: res.power_source,
          max_speed: res.max_speed
        });
      })
    }
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      brand: ['', Validators.required],
      model: ['', Validators.required],
      manufacturing_year: ['', Validators.required],
      serial_number: ['', Validators.required],
      weight: '',
      length: '',
      wingspan: '',
      power_source: '',
      max_speed: ''
    })
  }

  initForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      brand: ['', Validators.required],
      model: ['', Validators.required],
      manufacturing_year: ['', Validators.required],
      serial_number: ['', Validators.required],
      weight: '',
      length: '',
      wingspan: '',
      power_source: '',
      max_speed: ''
    })
  }

  onSubmit() {
    
    if (!this.isFormValid) return this.toastr.error(this._t.instant('Please fill in required (*) fields'), this._t.instant('Insufficient Info'));
    this.spinner.show();
    if (this.id) {
      this.droneService.update(this.id, this.form.getRawValue()).subscribe(res =>
        this.onSuccess(), ({ error }) => this.onError({ error }))
    } else {
      this.droneService.create(this.form.getRawValue()).subscribe(res =>
        this.onSuccess(), ({ error }) => this.onError({ error }))
    }
  }

  onSuccess() {
    this.spinner.hide();
    this.router.navigate(['drones']);
  }

  onError(error) {
    this.spinner.hide();
    const msg = error.message.reduce((results, u) => (results += u + ', ', results), '').slice(0, -2)
    this.toastr.error(this._t.instant(msg), this._t.instant('Error'));

  }
}
